var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    id: "_003_ECOMMERCE_03",
    "data-name": "003_ECOMMERCE_03",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "003_092") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10,20H4a2.00229,2.00229,0,0,1-2-2V6A2.00229,2.00229,0,0,1,4,4h6a1,1,0,0,1,0,2H4V18h6a1,1,0,0,1,0,2Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,22a1.0005,1.0005,0,0,1-1-1V3a.99985.99985,0,0,1,1.24268-.96973l8,2A.99971.99971,0,0,1,22,5V8.208a1,1,0,0,1-2,0V5.78125l-6-1.5v15.4375l6-1.5V12.208a1,1,0,1,1,2,0V19a.99971.99971,0,0,1-.75732.96973l-8,2A.97768.97768,0,0,1,13,22Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,14a.99974.99974,0,0,1-1-1V11a1,1,0,0,1,2,0v2A.99974.99974,0,0,1,17,14Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,9.25H21a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,17H21a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,16H7a1,1,0,0,1,0-2h3a1,1,0,0,1,0,2Z",
    style: {
      fill: "#333"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.71ff7febc38b1b5ee17578e6fba76534.svg";
export { ForwardRef as ReactComponent };